import { cn } from '@/lib/utils';
import './progress-ring.css';

export const ProgressRing = ({
  percentage = 0,
  className,
  circleClassName,
  backgroundClassName,
  strokeWidth = 16,
}: {
  percentage: number;
  className?: string;
  circleClassName?: string;
  backgroundClassName?: string;
  strokeWidth?: number;
}) => {
  return (
    <div
      className={cn(
        'flex items-center justify-center relative w-[20px] h-[20px]',
        className,
      )}
    >
      <svg className="w-full h-full transform rotate-180" viewBox="0 0 100 100">
        {/* <!-- Background circle --> */}
        <circle
          className={cn('text-gray-300 stroke-current', backgroundClassName)}
          strokeWidth={strokeWidth}
          cx="50"
          cy="50"
          r="40"
          fill="transparent"
        ></circle>
        {/* Progress circle */}
        <circle
          className={cn(
            'text-black progress-ring__circle stroke-current z-10',
            circleClassName,
          )}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          cx="50"
          cy="50"
          r="40"
          fill="transparent"
          strokeDasharray="251.2"
          strokeDashoffset={`calc(251.2px - (251.2px * ${percentage}) / 100)`}
        ></circle>
      </svg>
    </div>
  );
};
